import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'en' : import.meta.env.VITE_APP_LANG);

export const getDevToken = () =>
  `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc2MjEzNjAwNTIzOSwiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTAxODcyIn0.pGjGsy49knNHwx5MBbSqqT5J79zHZRd5uB-CclixWcZrEH08JV5OdP1UgWRJy40Kx6Z1MDe899cb8GoN0n2xHw`;

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
